import * as React from "react";
const VenmoIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={32}
        height={20}
        viewBox="0 0 32 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
            fill="white"
        />
        <path
            d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
            fill="white"
            fillOpacity={0.4}
        />
        <g clipPath="url(#clip0_77_3)">
            <path
                d="M7.94485 7.99997C8.10689 8.25848 8.17994 8.52476 8.17994 8.86111C8.17994 9.93391 7.23187 11.3276 6.4624 12.3062H4.70487L4 8.23485L5.53891 8.09372L5.91158 10.9907C6.2598 10.4427 6.6895 9.5816 6.6895 8.99449C6.6895 8.67312 6.63251 8.45423 6.54343 8.274L7.94485 7.99997Z"
                fill="#008CFF"
            />
            <path
                d="M9.9394 9.79302C10.2226 9.79302 10.9355 9.66788 10.9355 9.27647C10.9355 9.08852 10.798 8.99477 10.6358 8.99477C10.3522 8.99477 9.97996 9.32333 9.9394 9.79302ZM9.90695 10.5682C9.90695 11.0461 10.1821 11.2336 10.5468 11.2336C10.944 11.2336 11.3243 11.1399 11.8185 10.8972L11.6324 12.1184C11.2841 12.2828 10.7414 12.3924 10.2146 12.3924C8.87825 12.3924 8.39999 11.6096 8.39999 10.631C8.39999 9.36256 9.17795 8.01572 10.7818 8.01572C11.6649 8.01572 12.1587 8.49361 12.1587 9.15905C12.1588 10.2318 10.7334 10.5605 9.90695 10.5682Z"
                fill="#008CFF"
            />
            <path
                d="M16.5998 8.93982C16.5998 9.09638 16.5753 9.32347 16.5508 9.47188L16.0891 12.2906H14.5906L15.0118 9.70673C15.0198 9.63665 15.0443 9.49556 15.0443 9.41727C15.0443 9.22932 14.9228 9.18243 14.7766 9.18243C14.5825 9.18243 14.3879 9.26846 14.2583 9.33128L13.7806 12.2906H12.2737L12.9621 8.07053H14.2663L14.2828 8.40736C14.5905 8.21166 14.9957 8 15.5705 8C16.3322 7.99992 16.5998 8.37586 16.5998 8.93982Z"
                fill="#008CFF"
            />
            <path
                d="M21.0485 8.4777C21.4777 8.18049 21.8829 8.01572 22.4416 8.01572C23.211 8.01572 23.4787 8.39166 23.4787 8.95563C23.4787 9.1122 23.4541 9.33929 23.4297 9.4877L22.9685 12.3064H21.4696L21.8989 9.66793C21.9068 9.59739 21.9234 9.51136 21.9234 9.45679C21.9234 9.24516 21.8018 9.19823 21.6556 9.19823C21.4696 9.19823 21.2835 9.27651 21.1453 9.34708L20.6676 12.3064H19.1692L19.5984 9.66796C19.6063 9.59744 19.6225 9.51141 19.6225 9.45683C19.6225 9.24521 19.5007 9.19827 19.3552 9.19827C19.1606 9.19827 18.9665 9.28431 18.8369 9.34712L18.3587 12.3065H16.8523L17.5407 8.08637H18.829L18.8695 8.43868C19.1692 8.22754 19.574 8.01588 20.1167 8.01588C20.5866 8.01572 20.8942 8.21147 21.0485 8.4777Z"
                fill="#008CFF"
            />
            <path
                d="M26.4605 9.70692C26.4605 9.36241 26.3713 9.12753 26.1042 9.12753C25.5129 9.12753 25.3914 10.1374 25.3914 10.6541C25.3914 11.046 25.5049 11.2886 25.772 11.2886C26.3309 11.2886 26.4605 10.2235 26.4605 9.70692ZM23.8685 10.5917C23.8685 9.26086 24.5974 8.01559 26.2744 8.01559C27.5381 8.01559 28 8.73608 28 9.73055C28 11.0459 27.279 12.4082 25.5615 12.4082C24.2897 12.4082 23.8685 11.6016 23.8685 10.5917Z"
                fill="#008CFF"
            />
        </g>
        <defs>
            <clipPath id="clip0_77_3">
                <rect
                    width={24}
                    height={4.40816}
                    fill="white"
                    transform="translate(4 8)"
                />
            </clipPath>
        </defs>
    </svg>
);
export default VenmoIcon;
